import HelloWorld from '@/component/hello-world/index.vue'

export default {
  components: {
    HelloWorld,
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    // const __this = this;
  },
  activated() {
    // const __this = this;
  },
  deactivated() {
    // const __this = this;
  },
}
